import { useEffect, useState } from "react";

/** Breakpoint (px) below which the mobile layout is shown. Keep in sync with mobile layout usage. */
export const MOBILE_BREAKPOINT = 992;

/**
 * Returns true when viewport width is below the mobile breakpoint.
 * Use in any page or component to hide/fix elements for mobile view.
 *
 * @param {number} [breakpoint=MOBILE_BREAKPOINT] - Viewport width (px) below which isMobile is true
 * @returns {boolean} isMobile
 *
 * @example
 * const isMobile = useIsMobile();
 * return (
 *   <>
 *     {!isMobile && <Sidebar />}
 *     <Content className={isMobile ? 'mobile-padding' : ''} />
 *   </>
 * );
 */
const useIsMobile = (breakpoint = MOBILE_BREAKPOINT) => {
	const [isMobile, setIsMobile] = useState(() => window.innerWidth < breakpoint);

	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth < breakpoint);
		};
		window.addEventListener("resize", handleResize);
		handleResize(); // run once in case breakpoint changed
		return () => window.removeEventListener("resize", handleResize);
	}, [breakpoint]);

	return isMobile;
};

export default useIsMobile;
